import { useField } from 'formik';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Row, Spinner, Table } from 'reactstrap';

import Icon from '@/components/common/icon';
import { Error, Input, Select } from '@/components/form';
import getResource from '@/services/resources';
import { t } from '@/services/translator';
import LoadingLayout from '@/components/layout/loading-layout';

const Calculations = ({ index, getFieldHelpers, tags }) => {
  const [calculationParametersLoading, setCalculationParametersLoading] = useState(true);
  const [calculationParameters, setCalculationParameters] = useState({});
  const [calculationParametersOptions, setCalculationParametersOptions] = useState({});

  const [calculationsField] = useField({ name: `instances[${index}].calculations` });
  const { setValue, setError, setTouched } = getFieldHelpers(`instances[${index}].calculations`);
  const { value } = calculationsField;
  const [changePosition, setChangePosition] = useState(null);
  const [changePositionLoading, setChangePositionLoading] = useState(false);

  const getDefaultValue = (type, param) => {
    const params = calculationParameters[type];

    return params !== undefined && params[param] !== undefined ? String(params[param]) : null;
  };

  // On va lire value (si existant), on supprime l'id et enfin on intervertis les positions dans newValue
  const updatePosition = (alias, oldPosition) => {
    let newPosition = changePosition[alias];

    if (newPosition === undefined || (newPosition-1) === oldPosition) {
      return;
    }

    newPosition = newPosition - 1;

    setChangePositionLoading(true);

    setTimeout(() => {

    const newValue = value.map((calculation, i) => {
      return { ...calculation, id: null, "@id": null };
      });
  
      const [movedCalculation] = newValue.splice(oldPosition, 1);
      newValue.splice(newPosition, 0, movedCalculation);
  
      setChangePosition(null);
      setValue(newValue);

      setTimeout(() => {
        setChangePositionLoading(false);
      }, 250);
    }, 250);
  };

  useEffect(() => {
    getResource('Report')
      .fetchCalculationTypeParams()
      .then((calculationParametersResult) => {
        const options = Object.keys(calculationParametersResult).map((key) => ({ value: key, label: t(key) }));
        setCalculationParametersOptions(options);
        setCalculationParameters(calculationParametersResult);
        setCalculationParametersLoading(false);
      });
  }, []);

  return (
    <Row>
      {
        changePositionLoading ? <div style={{position: 'fixed', width: "100vw", height: "100vh", top: 0, left: 0, zIndex: 1000, backgroundColor: "rgba(0,0,0,0.5)"}}>
          <p style={{position: 'absolute', 'width': '100%', textAlign: 'center', top: '45%', color: "white", fontWeight: "bold"}}>Changement de position...</p>
        </div> : null
      }
      <Error name="calculations" />
      {(value || []).map((calculation, i) => {

        return (
          <Col lg={4} key={`calc_${i}`}>
            <Card className="mb-3 shadow" key={`card_${i}`}>
              <CardHeader className="p-2 flex justify-content-between align-items-center">
                <h5 className="m-0 d-flex justify-content-between align-items-center">
                  <span className="px-1">{t('calculation')} {i+1} </span>
                  <div style={{position: "relative"}}>
                    <input className="form-control" type="number" onChange={(e) => setChangePosition({[calculation.alias]: parseInt(e.target.value)})}/>
                    <Button size="sm" style={{position: "absolute", top: "50%", transform: "translateY(-50%)", right: "20px"}}
                      onClick={() => updatePosition(calculation.alias, i)}
                    >Ok</Button>
                  </div>
                </h5>
                <Button
                  size="sm"
                  color="gray"
                  outline
                  className="shadow-none"
                  onClick={() => {
                    value.splice(i, 1);
                    setValue(value);
                    setError({});
                    setTouched(false);
                  }}
                >
                  <Icon name="times" />
                </Button>
              </CardHeader>
              <CardBody className="p-3">
                <Row key={`row_${i}`}>
                  <Col lg={6}>
                    <Input name={`instances[${index}].calculations[${i}].alias`} />
                  </Col>
                  <Col lg={6}>
                    <Select
                      name={`instances[${index}].calculations[${i}].type`}
                      isLoading={calculationParametersLoading}
                      isDisabled={calculationParametersLoading}
                      options={calculationParametersOptions}
                      onSelect={(type) => {
                        const defaultParams = calculationParameters[type];
                        const parameters = Object.keys(defaultParams).map((name) => ({ name }));
  
                        value[i].type = type;
                        value[i].parameters = parameters;
  
                        setValue(value);
                      }}
                    />
                  </Col>
                  <Col lg={12}>
                    <Select name={`instances[${index}].calculations[${i}].tags`} options={tags} multiple />
                  </Col>
                  <Col lg={12}>
                    <Table>
                      <thead>
                        <tr>
                          <th>{t('report.calculation.parameter')}</th>
                          <th>{t('report.calculation.value')}</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {!calculationParametersLoading &&
                          (calculation.parameters || []).map((parameters, n) => (
                            <tr key={`parameter_${n}`}>
                              <td className="p-2">
                                <Input
                                  name={`instances[${index}].calculations[${i}].parameters[${n}].name`}
                                  label={false}
                                  groupTag="span"
                                />
                              </td>
                              <td className="p-2">
                                <Input
                                  name={`instances[${index}].calculations[${i}].parameters[${n}].value`}
                                  label={false}
                                  groupTag="span"
                                  placeholder={getDefaultValue(value[i].type, value[i].parameters[n].name)}
                                />
                              </td>
                              <td className="p-2">
                                <Button
                                  size="sm"
                                  color="gray"
                                  outline
                                  className="shadow-none"
                                  onClick={() => {
                                    const tmpValue = [...value];
                                    tmpValue[i].parameters.splice(n, 1);
                                    setValue(tmpValue);
                                  }}
                                >
                                  <Icon name="times" />
                                </Button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                    <div className="p-2">
                      <Button
                        color="light"
                        outline
                        size="sm"
                        onClick={() => {
                          const tmpValue = [...value];
                          tmpValue[i].parameters = tmpValue[i].parameters || [];
                          tmpValue[i].parameters.push({});
                          setValue(tmpValue);
                        }}
                      >
                        <Icon name="plus-circle" /> {t('add_parameter')}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        )
      })}
      <Col lg="12">
        <Button
          size="sm"
          color="secondary"
          className="mb-3"
          onClick={() => {
            const tmpValue = value ? [...value] : [];
            tmpValue.push({});
            setValue(tmpValue);
          }}
        >
          <Icon name="plus-circle" /> {t('add_calculation')}
        </Button>
      </Col>
    </Row>
  );
};

Calculations.propTypes = {
  index: PropTypes.number.isRequired,
  getFieldHelpers: PropTypes.func.isRequired
};

export default Calculations;
